import { Game } from '@src/core/models/games/Game';
import Virtual from '@src/core/models/games/Virtual';
import {
    gameService,
    GameCategory,
} from '@core/services/game/GameService';
import StoreUtil from '@store/StoreUtil';
import Favourite from '@core/models/games/Favourite';
import Banner from '@core/models/games/JackpotBanner';
import i18n from '@app/localization/i18n';
import gameComparator from '@core/utils/sortComparators/gameComparator';

const SET_GAMES = 'SET_GAMES';
const SET_CASINO_LIVE_GAMES = 'SET_CASINO_LIVE_GAMES';
const SET_VIRTUAL_NUMBER_GAMES = 'SET_VIRTUAL_NUMBER_GAMES';
const SET_VIRTUAL_SPORT_GAMES = 'SET_VIRTUAL_SPORT_GAMES';
const TOGGLE_FAVOURITE_GAME = 'TOGGLE_FAVOURITE_GAME';
const SET_FAVOURITE_GAMES = 'SET_FAVOURITE_GAMES';
const SET_JACKPOT_BANNER = 'SET_JACKPOT_BANNER';
const SET_GAMES_LOADED = 'SET_GAMES_LOADED';

interface IGames {
    [GameCategory.slots]: Game[];
    [GameCategory.jackpot]: Game[];
    [GameCategory.new]: Game[];
    [GameCategory.table]: Game[];
    [GameCategory.recommended]: Game[];
}

export interface IGamesState {
    games: IGames;
    favouriteGames: Record<number, boolean>;
    casinoLive: Game[];
    virtualNumber: Virtual[];
    virtualSport: Virtual[];
    banner: Banner;
    areGamesLoaded: boolean;
}

export default {
    namespaced: true,

    state: {
        games: {
            [GameCategory.slots]: [],
            [GameCategory.jackpot]: [],
            [GameCategory.new]: [],
            [GameCategory.table]: [],
            [GameCategory.recommended]: []
        },
        favouriteGames: {} as Record<number, boolean>,
        casinoLive: [],
        virtualNumber: [],
        virtualSport: [],
        banner: {
            levels: [],
            currency: '',
        },
        areGamesLoaded: false,
    } as IGamesState,

    mutations: {
        [SET_GAMES](state: IGamesState, payload: { games: Record<GameCategory, Game[]> }) {
            const games = payload.games;
            Object.entries(games).forEach(([key, games]: [any, Game[]]) => {
                (state.games as any)[key] = games.slice().sort(gameComparator);
            });
        },
        [SET_CASINO_LIVE_GAMES]: StoreUtil.createSimpleMutator('casinoLive'),
        [SET_VIRTUAL_NUMBER_GAMES]: StoreUtil.createSimpleMutator('virtualNumber'),
        [SET_VIRTUAL_SPORT_GAMES]: StoreUtil.createSimpleMutator('virtualSport'),
        [SET_FAVOURITE_GAMES]: StoreUtil.createSimpleMutator('favouriteGames'),
        [TOGGLE_FAVOURITE_GAME]: StoreUtil.createSetMutator('favouriteGames'),
        [SET_JACKPOT_BANNER]: StoreUtil.createSimpleMutator('banner'),
        [SET_GAMES_LOADED]: StoreUtil.createSimpleMutator('areGamesLoaded'),
    },

    getters: {
        casinoLive: StoreUtil.createSimpleGetter('casinoLive'),
        virtualNumber: StoreUtil.createSimpleGetter('virtualNumber'),
        virtualSport: StoreUtil.createSimpleGetter('virtualSport'),
        virtualGames: (state: IGamesState, getters: any) =>
            getters.virtualNumber.concat(getters.virtualSport),
        virtualShopsGames() {
            return [
                {
                    redirectUrl: 'greyhound##RETAIL',
                    name: i18n.t('greyhound retail'),
                    checkOriginUrl: 'https://seven-web-superbet.nsoft.ba'
                },
                {
                    redirectUrl: 'luckysix##RETAIL',
                    name: i18n.t('luckysix retail'),
                    checkOriginUrl: 'https://seven-web-superbet.nsoft.ba'
                },
                {
                    redirectUrl: 'roulette-retail',
                    name: i18n.t('roulette retail'),
                    checkOriginUrl: 'https://roulette-web.7platform.net',
                }
            ];
        },
        favouriteGameMap: StoreUtil.createSimpleGetter('favouriteGames'),
        banner: StoreUtil.createSimpleGetter('banner'),
        areGamesLoaded: StoreUtil.createSimpleGetter('areGamesLoaded'),
    },

    actions: {
        fetchAllGames: StoreUtil.asyncErrorGuard(async ({ commit }: { commit: any }) => {
            // const games = await gameService.getAllGames();
            // commit(
            //     SET_GAMES,
            //     {
            //         isMobile: false,
            //         games: games.desktopGames
            //     }
            // );
            // commit(
            //     SET_GAMES,
            //     {
            //         isMobile: true,
            //         games: games.mobileGames
            //     }
            // );
            // commit(SET_CASINO_LIVE_GAMES, games[GameCategory.casinoLive].sort(gameComparator));
            // commit(SET_VIRTUAL_NUMBER_GAMES, games[GameCategory.numbers].sort(gameComparator));
            // commit(SET_VIRTUAL_SPORT_GAMES, games[GameCategory.sport].sort(gameComparator));
            commit(SET_GAMES_LOADED, true);
        }),
        fetchFavouriteGames: StoreUtil.asyncErrorGuard(async ({ commit }: { commit: any }) => {
            // const favouriteGames = await gameService.getFavouriteGames();
            // const favouriteGamesMap = favouriteGames.reduce(
            //     (map: any, game: Favourite) => {
            //         map[game.gameId] = true;
            //         return map;
            //     },
            //     {});
            // // these are mobile and desktop combine!
            // commit(SET_FAVOURITE_GAMES, favouriteGamesMap);
        }),
        toggleFavouriteGame: StoreUtil.asyncErrorGuard(
            async ({ commit, getters }: { commit: any, getters: any }, gameId: number) => {
                // const isFavourite = !!getters.favouriteGameMap[gameId];
                // await gameService.toggleFavouriteGame(gameId, !isFavourite);
                // commit(TOGGLE_FAVOURITE_GAME, { key: gameId });
            }
        ),
        fetchJackpotBanner: StoreUtil.asyncErrorGuard(async ({ commit }: { commit: any }) => {
            const banner = await gameService.getJackpotBanner();
            if (!banner) {
                return;
            }
            commit(SET_JACKPOT_BANNER, banner);
        })
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/games/gameIndex.ts